var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16732 17.3334C0.946304 17.3334 0.734342 17.2456 0.578062 17.0893C0.421782 16.9331 0.333984 16.7211 0.333984 16.5001V1.50008C0.333984 1.27907 0.421782 1.06711 0.578062 0.910826C0.734342 0.754545 0.946304 0.666748 1.16732 0.666748H12.834C13.055 0.666748 13.267 0.754545 13.4232 0.910826C13.5795 1.06711 13.6673 1.27907 13.6673 1.50008V4.00008H12.0006V2.33341H2.00065V15.6667H12.0006V14.0001H13.6673V16.5001C13.6673 16.7211 13.5795 16.9331 13.4232 17.0893C13.267 17.2456 13.055 17.3334 12.834 17.3334H1.16732ZM12.0006 12.3334V9.83342H6.16732V8.16675H12.0006V5.66675L16.1673 9.00008L12.0006 12.3334Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.8a12c01fb8a25c91a3a73d1ffb98488e.svg";
export { ForwardRef as ReactComponent };